import React      from 'react';
import Navigation from './routes';

import { ToastContainer                   } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';

import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = (): React.ReactElement => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Navigation />
      <ToastContainer
        draggable
        closeOnClick
        pauseOnHover
        pauseOnFocusLoss
        rtl={true}
        theme='dark'
        position='top-right'
        autoClose={2000}
        newestOnTop={false}
        hideProgressBar={false}
      />
    </QueryClientProvider>
  );
};

export default App;
